<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="isOpen"
        class="fixed inset-0 z-50 overflow-y-auto"
      >
        <!-- Backdrop (no click-to-close) -->
        <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"></div>

        <!-- Modal -->
        <div class="flex min-h-full items-center justify-center p-4">
          <div class="relative bg-white border border-gray-200 dark:border-gray-700 dark:bg-black rounded-lg shadow-xl max-w-md w-full">
            <!-- Icon -->
            <div class="flex justify-center pt-8">
              <div
                class="w-16 h-16 rounded-full flex items-center justify-center"
                :style="{ backgroundColor: brandColors.primary + '20' }"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8" :style="{ color: brandColors.primary }">
                  <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clip-rule="evenodd" />
                </svg>
              </div>
            </div>

            <!-- Content -->
            <div class="px-6 pt-5 pb-2 text-center">
              <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                Complete Your Profile
              </h3>
              <p class="text-sm text-gray-600 dark:text-gray-400">
                Please complete your profile by providing your <strong>Mobile Number</strong> and <strong>City</strong> to continue using the system.
              </p>
            </div>

            <!-- Button -->
            <div class="px-6 pb-8 pt-4 flex justify-center">
              <button
                type="button"
                @click="$emit('complete')"
                class="px-6 py-2.5 text-white rounded-lg transition-all duration-200 font-medium flex items-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                :style="{ backgroundColor: brandColors.primary }"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 mr-2">
                  <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                  <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
                </svg>
                Complete Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useBrand } from '@/composables/brand/useBrand';

defineProps<{
  isOpen: boolean;
}>();

defineEmits<{
  complete: [];
}>();

const { brandColors } = useBrand();
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .bg-white,
.modal-leave-active .bg-white {
  transition: transform 0.3s ease;
}

.modal-enter-from .bg-white,
.modal-leave-to .bg-white {
  transform: scale(0.95);
}
</style>
